import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 flex w-full space-x-4" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-9/12 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-3/12 ml-auto rounded-full skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-start w-full opacity-0" }, [
    /*#__PURE__*/_createElementVNode("h3", {
      class: "flex-grow",
      style: {"display":"-webkit-box","-webkit-line-clamp":"2","-webkit-box-orient":"vertical","overflow":"hidden"}
    }, "   "),
    /*#__PURE__*/_createElementVNode("div", { class: "ml-auto" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mr-0 chip" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
          /*#__PURE__*/_createElementVNode("p", null, " ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex w-full mb-2 space-x-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 h-5 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 h-5 skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex w-full space-x-2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 h-5 skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 h-5 skeleton-unit" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between w-full mt-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-20 rounded-md skeleton-unit" }),
    /*#__PURE__*/_createElementVNode("div", { class: "w-20 rounded-md skeleton-unit" })
  ])
], -1)
const _hoisted_4 = { class: "opacity-0" }
const _hoisted_5 = { class: "flex flex-col h-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-1 mb-4 space-y-1 text-sm" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-1" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-1" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, " ")
  ])
], -1)
const _hoisted_7 = { class: "flex items-end mt-auto" }
const _hoisted_8 = { class: "flex mr-auto space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { marginLess: true }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Btn, null, {
                  default: _withCtx(() => [
                    _createTextVNode(" ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}